
if( $('#modal-relatar-problema').length ) {

    var vmRelatarProblema = new Vue({
        el: '#modal-relatar-problema',
        data: {
            id: null,
            problemas: {},
            urlAjax: '',
            tipoPost: '',
            problemaSelecionado: -1,
            descricao: null,
            lightbox: lity()
        },
        methods: {
            abrirModal: function (id, tipo) {

                this.id = id;
                this.tipoPost = tipo;
                this.problemaSelecionado = -1;
                this.descricao = null;

                /* Abre o modal */
                this.lightbox('#modal-relatar-problema');
            },
            enviar: function () {

                if (this.problemaSelecionado == -1 || !this.descricao) {
                    return -1;
                }

                ajaxPOST(
                    this.urlAjax,
                    {
                        id: this.id,
                        problema: this.problemaSelecionado,
                        descricao: this.descricao,
                        tipoPost: this.tipoPost
                    }
                );

                this.lightbox.close();
            }
        }
    });

}